module.exports = __webpack_public_path__ + "static/media/calendar.61c2fe93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/calendar.svg
// module id = 490
// module chunks = 1